import { render } from "./TdSuccessCase.vue?vue&type=template&id=45f54c81&scoped=true"
import script from "./TdSuccessCase.vue?vue&type=script&lang=js"
export * from "./TdSuccessCase.vue?vue&type=script&lang=js"

import "./TdSuccessCase.vue?vue&type=style&index=0&id=45f54c81&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f54c81"]])

export default __exports__